var _this3 = this;

function _newArrowCheck(innerThis, boundThis) { if (innerThis !== boundThis) { throw new TypeError("Cannot instantiate an arrow function"); } }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue'; //
//
//
//
//
//

var ANIMATION_TIME = 1500;
var _opt = {
  entry: '#downLoadEntry',
  message: '文件准备中,请进入下载中心查看'
};
var script = {
  name: 'FlyIn',
  data: function data() {
    return {
      open: false
    };
  },
  methods: {
    show: function show(opt) {
      var _this = this;

      var _opt$opt = _objectSpread(_objectSpread({}, _opt), opt),
          el = _opt$opt.el,
          entry = _opt$opt.entry,
          message = _opt$opt.message;

      this.open = true;
      var p = el.getBoundingClientRect();
      var downLoadEntry = document.querySelector(entry).getBoundingClientRect();
      var fly = "\n       @keyframes yx-fly{\n        0%{\n          transform: scale(0.5);\n          top: ".concat(p.top, "px;\n          left: ").concat(p.left, "px;\n        }\n        10%{\n          transform: scale(2.3);\n          top: ").concat(p.top, "px;\n          left: ").concat(p.left, "px;\n        }\n        20%{\n          transform: scale(2.3);\n          top: ").concat(p.top, "px;\n          left: ").concat(p.left, "px;\n        }\n        30%{\n          transform: scale(2.3);\n          top: ").concat(p.top, "px;\n          left: ").concat(p.left, "px;\n        }\n        50%{\n          transform: scale(1);\n        }\n        90%{\n          opacity: 0.5;\n\n        }\n        100%{\n          top: ").concat(downLoadEntry.top, "px;\n          opacity: 0;\n          left: ").concat(downLoadEntry.left, "px;\n        }\n      }\n      ");
      var style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = fly;
      document.querySelector('head').appendChild(style);
      this.$refs.ball.style.animation = "yx-fly ".concat(ANIMATION_TIME, "ms forwards");
      this.$notify({
        message: message,
        offset: 65,
        type: 'success'
      });
      setTimeout(function () {
        var _this2 = this;

        _newArrowCheck(this, _this);

        this.open = false;
        style.remove();
        this.$nextTick(function () {
          _newArrowCheck(this, _this2);

          this.$refs.ball.remove();
          this.$destroy();
        }.bind(this));
      }.bind(this), ANIMATION_TIME);
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}
/* script */


var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.open,
      expression: "open"
    }],
    ref: "ball",
    staticClass: "yx-ball",
    "class": {
      on: _vm.open
    }
  }, [_c("i", {
    staticClass: "el-icon-download yx-ball-icon-download"
  })]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var newInstance = null; // 将vue组件进行构造函数转换

var AlertConstructor = Vue.extend(__vue_component__);

var init = function init() {
  _newArrowCheck(this, _this3);

  // 将组件实例化
  newInstance = new AlertConstructor({
    el: document.createElement('div')
  }); // 加载dom

  document.body.appendChild(newInstance.$el);
}.bind(this);

var caller = function caller(options) {
  _newArrowCheck(this, _this3);

  // options 调用时传入配置项
  // console.log(options)
  // console.log(newInstance)
  init();

  for (var prop in options) {
    // eslint-disable-next-line no-prototype-builtins
    if (options.hasOwnProperty(prop)) {
      newInstance[prop] = options[prop];
    }
  } // Vue.nextTick(() => {
  //   newInstance.open = true
  // })


  return newInstance.show(options);
}.bind(this);

__vue_component__.install = function (Vue) {
  _newArrowCheck(this, _this3);

  Vue.prototype.$FlyIn = caller.bind(null);
}.bind(this);

var FlyIn = caller;
export default __vue_component__;
export { FlyIn };
